import { Keys } from 'excalibur';
import { button } from './button';
import { KeyboardLike } from './KeyboardLike';
import { stick } from './stick';

// Player 2 (right keyboard) mapping: Arrow keys + RightShift, keypad-ish extras

export const rightKeyboard = (keyboard: KeyboardLike) => {
    return {
        leftStick: stick(keyboard, {
            left: Keys.Left,
            right: Keys.Right,
            up: Keys.Up,
            down: Keys.Down,
            press: Keys.ShiftRight,
        }),
        rightStick: stick(keyboard, {
            left: Keys.Num4,
            right: Keys.Num6,
            up: Keys.Num8,
            down: Keys.Num5,
            press: Keys.Num0,
        }),
        aOrCross: button(keyboard, Keys.ControlRight),
        bOrCircle: button(keyboard, Keys.Slash),
        xOrSquare: button(keyboard, Keys.Period),
        yOrTriangle: button(keyboard, Keys.Comma),
        leftBumper: button(keyboard, Keys.BracketRight),
        rightBumper: button(keyboard, Keys.Backslash),
        leftTrigger: {
            get holding() {
                return keyboard.isHeld(Keys.Num1) ? 1 : 0;
            },
            get pressed() {
                return keyboard.wasPressed(Keys.Num1);
            },
        },
        rightTrigger: {
            get holding() {
                // return keyboard.isHeld(Keys.Num3) ? 1 : 0;
                return keyboard.isHeld(Keys.M) ? 1 : 0;
            },
            get pressed() {
                // return keyboard.wasPressed(Keys.Num3);
                return keyboard.wasPressed(Keys.M);
            },
        },
        back: button(keyboard, Keys.Backspace),
        start: button(keyboard, Keys.Enter), // REnter not present in all versions
        dpadUp: button(keyboard, Keys.Up),
        dpadDown: button(keyboard, Keys.Down),
        dpadLeft: button(keyboard, Keys.Left),
        dpadRight: button(keyboard, Keys.Right),
    };
};
